import { Badge, Box, Breadcrumbs, Button, Grid, IconButton, LinearProgress, Menu, MenuItem, Stack, SvgIcon, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
// import CardAdd from '../../components/CardAdd';
// import PolylineIcon from '@mui/icons-material/Polyline';
// import GroupIcon from '@mui/icons-material/Group';
import { useDispatch, useSelector } from 'react-redux';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CreateDialog from '../../../components/CreateDialog';
import { v4 as uuidv4 } from 'uuid';
import { DataGridPremium, GridActionsCellItem, GridToolbarContainer, GridToolbarQuickFilter, useGridApiRef } from '@mui/x-data-grid-premium';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import ConfirmDialogReuse from '../ReuseComponents/ConfirmDialogReuse';
import EditDialog from '../../../components/EditDialog';
import { CustomTooltip } from '../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../components/TooltipStatusTitle';
import ErrorIcon from '@mui/icons-material/Error';
import checkUpdateSubjectSchema from '../../../utils/checkUpdateSubjectSchema';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import checkDiagramError from '../../../utils/checkDiagramError';
import checkDRGValidationFrontend from '../../../utils/checkDRGValidationFrontend';
import { gzip } from 'pako';
import { getProfile } from '../../../redux/iaamSlice';
import { setOpenDrawerLeft, setOpenDrawerRight, setOpenPreviewDRG, setOpenSimulatorDRG, setOpenSimulatorPolicy } from '../../../redux/layoutControlSlice';
import { setCurrentDRG } from '../../../redux/drgMgtSlice';

function ProjectWorkSpace() {

    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [drgCount, setDrgCount] = useState(0);
    const [drgErrorCount, setDrgErrorCount] = useState(0);
    const [project, setProject] = useState();
    const [waiting, setWaiting] = useState(false);
    const [policyFiles, setPolicyFiles] = useState([]);
    const [policySelected, setPolicySelected] = useState(null);

    // const apiRef = useGridApiRef();
    const [isLoading, setIsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);

    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);

    const [openDelete, setOpenDelete] = useState(false);

    const [fetchPolicies, setFetchPolicies] = useState(false);

    const profile = useSelector(getProfile);

    useEffect(() => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project) {
            setProject(project);
        }
    }, []);

    const columns = [
        {
            field: 'policy_diagram_name',
            headerName: 'Policy(s)',
            minWidth: 300,
            flex: 1,
            renderCell: (params) => {
                const onClick = () => {
                    handleSelectedPolicy(params.row);
                };
                const item = params.row;
                const filterSummary = item?.validation?.map(v => v.summary) || [];
                return (
                    <>
                        {filterSummary.length > 0 && (
                            <CustomTooltip
                                title={
                                    <TooltipStatusTitle
                                        headerTitle="Error"
                                        listDetails={filterSummary}
                                    />
                                }
                                arrow
                                placement="top"
                                tooltipcolorstyle={theme.palette.error.main}
                            >
                                <ErrorIcon
                                    sx={{
                                        color: theme.palette.error.main,
                                        fontSize: 16,
                                        marginRight: 0.5
                                    }}
                                />
                            </CustomTooltip>
                        )}
                        <a
                            href="#"
                            className="text-blue-900 font-primary"
                            onClick={onClick}
                            style={{
                                display: 'inline-flex', // Ensure the link stays inline with the icon
                                alignItems: 'center', // Align text vertically with the icon
                            }}
                        >
                            {params.row.policy_diagram_name}
                        </a>
                    </>
                )
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 220
        },
        {
            field: 'created_by',
            headerName: 'Created by',
            width: 220
        },
        {
            field: 'last_updated',
            headerName: 'Last Modified',
            width: 200
        },
        {
            field: 'actions',
            type: 'actions',
            width: 60,
            getActions: (params) => [
                <GridActionsCellItem
                    key={`action-${params.id}`}
                    icon={<MoreVertIcon />}
                    label="Action"
                    onClick={(e) => handleActionClick(params.row, e)}
                />,
            ],
        },
    ];

    const getDRGCount = async () => {
        const response = await fetch(process.env.REACT_APP_API_URL + `/misc/policy-drg-count/${project.project_id}`);
        if (response.status === 200) {
            const result = await response.json();
            setDrgCount(result.total_drg_count);
            setDrgErrorCount(result.drg_error_count);
        } else {
            console.error(response.status);
        }
    };

    const handleClearSelectedFile = () => {
        dispatch(setCurrentDRG(undefined));
        dispatch(setOpenDrawerRight(false));
        dispatch(setOpenPreviewDRG(false));
        dispatch(setOpenSimulatorDRG(false));
        dispatch(setOpenSimulatorPolicy(false));
    };

    const getListClients = async () => {
        try {
            const response = await fetch(`https://${process.env.REACT_APP_OP_HOST}/iap-api/get-clients?app_type=WEB,NATIVE,API`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const getPoliciesByProjectId = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/policy-diagram/get-policies/${project.project_id}`);
            if (response.status === 200) {
                const result = await response.json();
                const updatedItems = result
                    // .filter(item => item.creator_id === profile.inum || item.updated_id === profile.inum)
                    .map((item, index) => ({
                        ...item,
                        id: index,
                        last_updated: dayjs(item.last_updated).format("YYYY-MM-DD HH:mm:ss"),
                    }));
                // setPolicyFiles(updatedItems)
                const clients = await getListClients();
                const isSubjectSchema = await checkUpdateSubjectSchema(dispatch);
                if (!isSubjectSchema) {
                    const updateSubjectSchemaValidation = updatedItems.map(policy => {
                        const mapDrgValidation = checkDRGValidationFrontend(policy?.diagram.nodes, policy?.validation, clients);
                        const policyUpdateValidation = {
                            ...policy,
                            diagram: {
                                ...policy.diagram,
                                nodes: mapDrgValidation
                            }
                        }
                        const checkDiagramErrorValidation = checkDiagramError(policyUpdateValidation);
                        return {
                            ...checkDiagramErrorValidation,
                            validation: [...checkDiagramErrorValidation.validation, {
                                code: 'SUBJECT_SCHEMA_FETCH_FAILED',
                                summary: 'Subject schema fetch failed. Please try again.',
                                detail: []
                            }]
                        }
                    })

                    setPolicyFiles(updateSubjectSchemaValidation);
                } else {
                    const updateDiagramErrorValidation = updatedItems.map(policy => {
                        const mapDrgValidation = checkDRGValidationFrontend(policy?.diagram.nodes, policy?.validation, clients);
                        const policyUpdateValidation = {
                            ...policy,
                            diagram: {
                                ...policy.diagram,
                                nodes: mapDrgValidation
                            }
                        }
                        const checkDiagramErrorValidation = checkDiagramError(policyUpdateValidation);
                        return checkDiagramErrorValidation
                    })
                    setPolicyFiles(updateDiagramErrorValidation);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (project) {
            getDRGCount();
            getPoliciesByProjectId();
        }
    }, [project])

    useEffect(() => {
        if (fetchPolicies) {
            getPoliciesByProjectId();
            setFetchPolicies(false);
        }
    }, [fetchPolicies])

    const handleOpenCreatePolicy = () => {
        setOpenCreateDialog(true);
    };

    const handleCreatePolicy = async (name, desc) => {
        setWaiting(true);
        const create_ts = Date.now();
        const initial = {
            policy_diagram_id: uuidv4(),
            policy_diagram_name: name,
            creator_id: profile.inum,
            created_by: profile.displayName,
            updated_id: profile.inum,
            updated_by: profile.displayName,
            created_at: create_ts,
            last_updated: create_ts,
            description: desc,
            status: "Unverified",
            validation: [],
            diagram: {
                nodes: [],
                edges: []
            }
        }
        const requestOptions = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(initial)
        };

        const response = await fetch(`${process.env.REACT_APP_API_URL}/policy-diagram/add-policy/${project.project_id}`, requestOptions);
        if (response.status === 200) {
            const result = await response.json();
            setWaiting(false);
            localStorage.setItem('policy-file', JSON.stringify(initial));
            navigate('/editor/policy');
            dispatch(setOpenDrawerLeft(true));
            // setResponseStatus("Project has been created successfully");
            // setOpenResponse(true);
        } else {
            console.error(response.status);
            setWaiting(false);
            // setResponseStatus(`Error status: ${response.status}`);
            // setOpenResponse(true);
        }
    };

    const handleDuplicate = async (name) => {
        try {
            const requestOptions = {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    project_id: project.project_id,
                    policy_diagram_name: name,
                })
            };
            const response = await fetch(process.env.REACT_APP_API_URL + '/policy-diagram/check-duplicate-policy', requestOptions);
            if (response.status === 200) {
                const result = await response.json();
                if (result.isDuplicate) {
                    return true;
                } else {
                    return false;
                }
            } else {
                throw "Failed to retrieve data. Please try again later.";
            }
        } catch (error) {
            throw error;
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function CustomToolbar(props) {

        return (
            <GridToolbarContainer {...props} className="mt-2 ml-2">
                <GridToolbarQuickFilter variant="outlined" size="small" />
            </GridToolbarContainer>
        );
    }

    const handleDeletePolicy = () => {
        setAnchorEl(null);
        setOpenDelete(true)
    };

    const handleActionClick = (row, e) => {
        setPolicySelected(row)
        setAnchorEl(e.currentTarget);
    }

    const handleDelete = async () => {
        setLoading(true);

        const policy_id = policySelected?.policy_diagram_id;
        const project_id = project?.project_id;

        // const requestOptions = {
        //     method: "DELETE",
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({
        //         policy_ids: [policySelected.policy_diagram_id],
        //     })
        // };

        // const response = await fetch(process.env.REACT_APP_API_URL + `/policy-diagram/delete-policies`, requestOptions);
        const requestOptions = {
            method: "DELETE"
        };

        const response = await fetch(process.env.REACT_APP_API_VALIDATION_URL + `/verify/delete-policy?policy_id=${policy_id}&project_id=${project_id}`, requestOptions);
        if (response.status === 200) {
            // localStorage.removeItem('policy-file');
            setPolicySelected(null);
            setFetchPolicies(true);
            setLoading(false);
            setOpenDelete(false);


            // setResponseStatus("The project and their associated diagrams have been deleted.");
            // setOpenResponse(true);
        } else {
            console.error(response.status);
            setLoading(false);
            // setResponseStatus(`Error status: ${response.status}`);
            // setOpenResponse(true);
        }

    };

    const handleSelectedPolicy = (row) => {
        localStorage.setItem('policy-file', JSON.stringify(row));
        navigate('/editor/policy');
        dispatch(setOpenDrawerLeft(true));
        dispatch(setOpenSimulatorPolicy(false));
    };

    const handleEditPolicy = () => {
        setAnchorEl(null);
        setOpenEditDialog(true);
    };

    const handleEditPolicyFile = async (name, desc) => {
        setWaiting(true);
        const update = {
            ...policySelected,
            policy_diagram_name: name,
            description: desc,
            updated_id: profile.inum,
            updated_by: profile.displayName,
            last_updated: Date.now()
        };
        const gzippedBody = gzip(JSON.stringify(update)); // บีบอัดข้อมูลด้วย gzip
        const requestOptions = {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
                'Content-Encoding': 'gzip', // Inform the server the body is gzipped
            },
            body: gzippedBody
        };

        const response = await fetch(`${process.env.REACT_APP_API_URL}/policy-diagram/update-policy/${policySelected.policy_diagram_id}`, requestOptions);
        if (response.status === 200) {
            // const result = await response.json();
            setFetchPolicies(true);
            setWaiting(false);
        } else {
            console.error(response.status);
            setWaiting(false);
        }
    };

    return (
        <section className="overflow-auto w-full bg-gradient-to-r from-blue-50 via-blue-50 to-blue-100">
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 overflow-hidden w-full'>
                <div className='pt-10'>
                    <div role='presentation'>
                        <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
                            <Link underline="hover" key="1" color="inherit" component={Link} to="/editor">
                                <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6'>
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Policy Editor
                                </Typography>
                            </Link>
                            <Typography color="primary" sx={{ display: 'flex', alignItems: 'center' }} variant='h6'>
                                {project?.project_name}
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className='animate-fade-left'>
                    <div className='flex justify-between bg-white rounded-md h-24 p-4 mt-8 border border-gray-200'>
                        <div className='h-full content-evenly'>
                            <Typography variant='h6'>Data Regulatory Graph</Typography>
                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>Manage the Regulatory, Subject and Object</Typography>
                        </div>
                        <div className='grid grid-flow-col gap-4 h-full content-evenly'>
                            <div className='h-full content-evenly'>
                                <Typography variant='subtitle2'>Total {drgCount} DRG(s)</Typography>
                                {drgErrorCount > 0 && <Typography variant='subtitle2'>Error {drgErrorCount} DRG(s)</Typography>}
                            </div>
                            {drgErrorCount > 0 ? (
                                <Badge
                                    color="error"
                                    badgeContent={<PriorityHighIcon style={{ fontSize: 12, padding: 0, margin: 0 }} />}
                                    sx={{
                                        "& .MuiBadge-badge": {
                                            padding: '0 4px',
                                            height: '20px',
                                            minWidth: '20px',
                                            borderRadius: '50%'
                                        }
                                    }}
                                >
                                    <Button style={{ textTransform: 'none' }} variant="contained"
                                        component={Link}
                                        to="/editor/regulatory"
                                        onClick={() => handleClearSelectedFile()}>
                                        DRG Management
                                    </Button>
                                </Badge>
                            ) : (
                                <Button style={{ textTransform: 'none' }} variant="contained"
                                    component={Link}
                                    to="/editor/regulatory"
                                    onClick={() => handleClearSelectedFile()}>
                                    DRG Management
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className='flex flex-col gap-1 mt-4'>
                        <div className='flex justify-between bg-white rounded-t-md h-24 p-4 border border-gray-200'>
                            <div className='h-full content-evenly'>
                                <Typography variant='h6'>Policy</Typography>
                                <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}>Create new Policy</Typography>
                            </div>
                            <div className='h-full content-evenly'>
                                <Button style={{ textTransform: 'none' }} variant="contained" onClick={() => handleOpenCreatePolicy()}>
                                    New Policy
                                </Button>
                            </div>
                        </div>
                        <div className='bg-white rounded-b-md h-[calc(100vh-380px)] max-h-[calc(100vh-178px)] mb-3 border border-gray-200'>
                            <DataGridPremium
                                // apiRef={apiRef}
                                loading={isLoading}
                                rows={policyFiles}
                                columns={columns}
                                disableRowSelectionOnClick
                                disableDensitySelector
                                slots={{ loadingOverlay: LinearProgress, toolbar: CustomToolbar }}
                                sx={{
                                    border: 0
                                }}
                            />
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleEditPolicy}>Edit</MenuItem>
                                <MenuItem onClick={handleDeletePolicy}>Delete</MenuItem>
                            </Menu>
                        </div>
                    </div>

                    <CreateDialog
                        open={openCreateDialog}
                        onClose={() => setOpenCreateDialog(false)}
                        title="Create Policy"
                        // subTitle="test"
                        onSubmit={handleCreatePolicy}
                        waiting={waiting}
                        onValidate={handleDuplicate}
                    />

                    <EditDialog
                        open={openEditDialog}
                        onClose={() => setOpenEditDialog(false)}
                        title="Edit Policy"
                        // subTitle="test"
                        onSubmit={handleEditPolicyFile}
                        waiting={waiting}
                        policySelected={policySelected}
                    // onValidate={handleDuplicate}
                    />

                    <ConfirmDialogReuse
                        open={openDelete}
                        maxWidth={"sm"}
                        content={
                            <div>
                                <Typography variant="subtitle1">Are you sure you want to delete policy "{policySelected?.policy_diagram_name}" ?</Typography>
                            </div>
                        }
                        actions={
                            <div className='grid grid-cols-2 gap-2'>
                                <LoadingButton
                                    variant="contained"
                                    loading={loading}
                                    onClick={() => handleDelete()}
                                >
                                    Confirm
                                </LoadingButton>
                                <Button
                                    disabled={loading}
                                    variant="outlined"
                                    onClick={() => setOpenDelete(false)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        }
                    />

                </div>
            </div>
        </section>
    )
}

export default ProjectWorkSpace